import {
  CODIGOS_SUBCATEGORIAS_VIAGEM_TICKET, CODIGO_CATEGORIA_PASSAGEM_AEREA, NOMES_SUBCATEGORIAS_VIAGEM_TICKET,
} from "../../constants/custosGeraisProjeto";

// Modo de cálculo do "Lançar Viagem" (Despesas Gerais e Custos Gerais por Projeto): "ticket"
// (padrão) = ticket médio travado × pessoas × viagens (× dias); "valor_total" = custo digitado
// direto por subcategoria, sem pessoas/viagens/dias. Backend: GrupoViagem*.modo_valor e
// FaixaViagem*.valores_subcategoria (ver _aplicar_modo_linha_viagem nos dois services).
export const MODOS_VALOR_VIAGEM = [
  { value: "ticket", label: "Ticket médio", descricao: "Ticket × pessoas × viagens × dias" },
  { value: "valor_total", label: "Custo total", descricao: "Informe só o valor de cada subcategoria" },
];

export function codigosValorTotalViagem(incluirPassagemAerea) {
  return CODIGOS_SUBCATEGORIAS_VIAGEM_TICKET.filter((c) => incluirPassagemAerea || c !== CODIGO_CATEGORIA_PASSAGEM_AEREA);
}

export function somaValorTotalFaixa(faixa, incluirPassagemAerea) {
  return codigosValorTotalViagem(incluirPassagemAerea).reduce((acc, c) => acc + Number(faixa.valores_subcategoria?.[c] || 0), 0);
}

// Payload de valores_subcategoria só com as subcategorias incluídas (Passagem Aérea desmarcada não vai).
export function valoresSubcategoriaPayload(faixa, incluirPassagemAerea) {
  return Object.fromEntries(codigosValorTotalViagem(incluirPassagemAerea).map((c) => [c, Number(faixa.valores_subcategoria?.[c]) || 0]));
}

// Reconstrói as faixas de um grupo já lançado no modo "valor_total" para reabrir o modal:
// todas as linhas do grupo têm as mesmas faixas (mesma ordem), cada linha guarda o valor da sua
// subcategoria. `linhas` = [{ codigo, faixas: [{ mes_inicio, mes_fim, valor }] }] (sem a Verba).
export function faixasValorTotalDoGrupo(linhas, faixasVerba) {
  const base = linhas[0]?.faixas || [];
  return base.map((f, idx) => ({
    mes_inicio: f.mes_inicio, mes_fim: f.mes_fim,
    n_pessoas: 1, n_viagens: 1, n_dias: 2, reajuste_pct: 0,
    verba_relacionamento: faixasVerba?.[idx]?.valor ?? 0,
    valores_subcategoria: Object.fromEntries(linhas.map((l) => [l.codigo, l.faixas[idx]?.valor ?? 0])),
  }));
}

export function SeletorModoValorViagem({ C, modo, onChange }) {
  return (
    <div style={{ display: "flex", gap: 6 }}>
      {MODOS_VALOR_VIAGEM.map((m) => {
        const ativo = modo === m.value;
        return (
          <button
            key={m.value}
            type="button"
            onClick={() => onChange(m.value)}
            style={{
              flex: 1, display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2, textAlign: "left",
              padding: "8px 12px", borderRadius: 8, cursor: "pointer", fontFamily: "inherit",
              border: `1px solid ${ativo ? C.brand : C.border}`,
              background: ativo ? `${C.brand}18` : "transparent",
            }}
          >
            <span style={{ fontSize: 12, fontWeight: 700, color: ativo ? C.brand : C.text }}>{m.label}</span>
            <span style={{ fontSize: 10, color: C.muted }}>{m.descricao}</span>
          </button>
        );
      })}
    </div>
  );
}

// Campos de custo direto de 1 período no modo "valor_total" — um por subcategoria incluída.
export function CamposValorTotalViagem({ C, faixa, incluirPassagemAerea, inputStyle, onChange }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 10 }}>
      {codigosValorTotalViagem(incluirPassagemAerea).map((codigo) => (
        <div key={codigo} style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label style={{ fontSize: 11, fontWeight: 700, color: C.muted }}>{NOMES_SUBCATEGORIAS_VIAGEM_TICKET[codigo]} (R$/mês)</label>
          <input
            type="number" min={0} step="0.01"
            value={faixa.valores_subcategoria?.[codigo] ?? 0}
            onChange={(e) => onChange({ ...(faixa.valores_subcategoria || {}), [codigo]: e.target.value })}
            style={inputStyle}
          />
        </div>
      ))}
    </div>
  );
}
